import { api } from "../../../api/config";
import { SplitPayment } from "../split-payment/splitPayments";

export type TerminalAttemptStatus = "pending" | "processing" | "paid" | "declined" | "cancelled" | "expired" | "failed";

export type RecordingStatus = "recorded" | "pending" | "needs_review";

export type TerminalAttempt = {
    id: number;
    status: TerminalAttemptStatus;
    amount: number;
    failure_reason: string | null;
    date_created: string;
    seconds_remaining: number;
    recording_status: RecordingStatus | null;
    split_payments: Array<SplitPayment>;
};

export type CancelReason = "operator" | "timeout";

export const OPEN_ATTEMPT_STATUSES: Array<TerminalAttemptStatus> = ["pending", "processing"];

export const isOpenAttempt = (attempt: TerminalAttempt | null) => {
    const isOpen = attempt !== null && OPEN_ATTEMPT_STATUSES.includes(attempt.status);
    return isOpen;
};

export const getPaymentsErrorMessage = (error: any) => {
    const errorMessage: string = error?.response?.data?.errors?.[0]?.message ?? "Não foi possível contactar o servidor.";
    return errorMessage;
};

export const fetchLatestTerminalAttempt = async (orderId: number) => {
    const response = await api.get("/payments/terminal/charges/latest", { params: { order_id: orderId } });
    const latestAttempt = response.data.data as TerminalAttempt | null;
    return latestAttempt;
};

export const startTerminalCharge = async (orderId: number, splitPayments: Array<SplitPayment>) => {
    const response = await api.post("/payments/terminal/charges", { order_id: orderId, split_payments: splitPayments });
    const startedAttempt = response.data.data as TerminalAttempt;
    return startedAttempt;
};

export const cancelTerminalAttempt = async (attemptId: number, reason: CancelReason) => {
    const response = await api.post(`/payments/terminal/charges/${attemptId}/cancel`, { reason });
    const cancelledAttempt = response.data.data as TerminalAttempt;
    return cancelledAttempt;
};
